import React from 'react';
import styles from './InitLoader.module.scss';
import { LogoLight } from 'esa-ui-library';

const InitLoader = (): JSX.Element => (
	<section className={styles.InitLoader}>
		<div className={styles.LoaderContent}>
			<div className={styles.Loader}></div>
			<LogoLight className={styles.Logo} />
		</div>
	</section>
);

export { InitLoader };
